<app-navbar [address]="address" (GetCountryId)="getCountryId($event)"></app-navbar>

<section class="section-padding contact-top bg-light-theme">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-header-left">
                    <h3 class="text-light-black header-title">{{'Send & Receive Service' | translate}}</h3>
                </div>

                <!-- Multiple Orders Section -->
                <div class="checkout-card mb-4">
                    <div class="d-flex align-items-center">
                        <i class="fas fa-boxes mr-2"></i>
                        <div>
                            <h5 class="mb-1 text-warning text-style-right">{{'MultipleOrders' | translate}}</h5>
                            <p class="mb-2">{{'Need to send multiple packages? Create batch orders with different details for each delivery.' | translate}}</p>
                        </div>
                    </div>
                    <button class="btn btn-warning text-white w-100" routerLink="/multiple-order">
                        {{'Create Batch Orders' | translate}}
                    </button>
                </div>

                <!-- Service Type Selection -->
                <div class="d-flex justify-content-center mb-4">
                    <div class="btn-group" role="group">
                        <button type="button" class="btn" [class.btn-primary]="serviceType === 'send'" (click)="setServiceType('send')">{{'Send' | translate}}</button>
                        <button type="button" class="btn" [class.btn-primary]="serviceType === 'receive'" (click)="setServiceType('receive')">{{'Receive' | translate}}</button>
                    </div>
                </div>

                <!-- Main Form -->
                <form [formGroup]="orderForm" (ngSubmit)="onSubmit()">
                    <!-- Sender Information -->
                    <div class="checkout-card mb-4">
                        <h4 class="text-warning text-style-right">{{'Sender Information' | translate}}</h4>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Sender Name' | translate}} *</label>
                                    <input type="text" class="form-control" [class.is-invalid]="isFieldInvalid('senderName')" formControlName="senderName">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('senderName')">
                                        {{getErrorMessage('senderName') | translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Phone' | translate}} *</label>
                                    <mat-form-field appearance="fill" class="w-100">
                                        <ngx-mat-intl-tel-input 
                                            formControlName="senderPhone" 
                                            [enablePlaceholder]="true"
                                            [preferredCountries]="['kw', 'jo']" 
                                            [enableSearch]="true"
                                            searchPlaceholder="{{'Search country' | translate}}" 
                                            [cssClass]="'custom form-control'">
                                        </ngx-mat-intl-tel-input>
                                    </mat-form-field>
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('senderPhone')">
                                        {{getErrorMessage('senderPhone') | translate}}
                                    </div>
                                    <mat-error *ngIf="(orderForm.get('senderPhone').dirty) && orderForm.get('senderPhone').errors && orderForm.get('senderPhone').errors.invalidPhoneNumber">
                                        {{'PhoneNumberNotValid' | translate}}
                                    </mat-error>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{'Sender Location' | translate}} *</label>
                                    <div class="location-wrapper">
                                        <div class="input-group">
                                            <input type="text" class="form-control" [class.is-invalid]="isFieldInvalid('senderAddress')" formControlName="senderAddress" readonly>
                                            <div class="input-group-append">
                                                <button type="button" class="btn btn-primary" (click)="openMap('sender')">
                                                    <i class="fas fa-map-marker-alt"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="invalid-feedback" *ngIf="isFieldInvalid('senderAddress')">
                                            {{getErrorMessage('senderAddress') | translate}}
                                        </div>
                                        <div class="map-container" [class.show]="currentLocationTarget === 'sender' && isMapVisible">
                                            <div class="map-header">
                                                <div class="input-group">
                                                    <input #senderSearchInput type="text" class="form-control" placeholder="{{'SearchForLocation' | translate}}">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-primary d-none" (click)="searchLocation('sender')">
                                                            <i class="fas fa-search"></i>
                                                        </button>
                                                        <button type="button" class="btn btn-secondary" (click)="closeMap()">
                                                            <i class="fas fa-times"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="map-content">
                                                <div #senderMapContainer class="map-view"></div>
                                            </div>
                                            <div class="map-footer">
                                                <button type="button" class="btn btn-primary" (click)="confirmLocation()">
                                                    <i class="fas fa-check"></i> {{'ConfirmLocation' | translate}}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'City' | translate}} *</label>
                                    <input type="text" class="form-control" [class.is-invalid]="isFieldInvalid('senderCity')" formControlName="senderCity">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('senderCity')">
                                        {{getErrorMessage('senderCity') | translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Region/Area' | translate}} *</label>
                                    <input type="text" class="form-control" [class.is-invalid]="isFieldInvalid('senderRegion')" formControlName="senderRegion">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('senderRegion')">
                                        {{getErrorMessage('senderRegion') | translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{'Street' | translate}}</label>
                                    <input type="text" class="form-control" formControlName="senderStreet">
                                    <!-- <div class="invalid-feedback" *ngIf="isFieldInvalid('senderStreet')">
                                        {{getErrorMessage('senderStreet') | translate}}
                                    </div> -->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Building No.' | translate}}</label>
                                    <input type="text" class="form-control" [class.is-invalid]="isFieldInvalid('senderBuildingNo')" formControlName="senderBuildingNo">
                                    <!-- <div class="invalid-feedback" *ngIf="isFieldInvalid('senderBuildingNo')">
                                        {{getErrorMessage('senderBuildingNo') | translate}}
                                    </div> -->
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Apartment No.' | translate}}</label>
                                    <input type="text" class="form-control" formControlName="senderApartmentNo">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Receiver Information -->
                    <div class="checkout-card mb-4">
                        <h4 class="text-warning text-style-right">{{'Receiver Information' | translate}}</h4>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Receiver Name' | translate}}</label>
                                    <input type="text" class="form-control" formControlName="receiverName" [class.is-invalid]="isFieldInvalid('receiverName')">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('receiverName')">
                                        {{getErrorMessage('receiverName') | translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Phone' | translate}}</label>
                                    <mat-form-field appearance="fill" class="w-100">
                                        <ngx-mat-intl-tel-input 
                                            formControlName="receiverPhone" 
                                            [enablePlaceholder]="true"
                                            [preferredCountries]="['kw', 'jo']" 
                                            [enableSearch]="true"
                                            searchPlaceholder="{{'Search country' | translate}}" 
                                            [cssClass]="'custom form-control'">
                                        </ngx-mat-intl-tel-input>
                                    </mat-form-field>
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('receiverPhone')">
                                        {{getErrorMessage('receiverPhone') | translate}}
                                    </div>
                                    <mat-error *ngIf="(orderForm.get('receiverPhone').dirty) && orderForm.get('receiverPhone').errors && orderForm.get('receiverPhone').errors.invalidPhoneNumber">
                                        {{'PhoneNumberNotValid' | translate}}
                                    </mat-error>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{'Receiver Location' | translate}} *</label>
                                    <div class="location-wrapper">
                                        <div class="input-group">
                                            <input type="text" class="form-control" formControlName="receiverAddress" readonly>
                                            <div class="input-group-append">
                                                <button type="button" class="btn btn-primary" (click)="openMap('receiver')">
                                                    <i class="fas fa-map-marker-alt"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="map-container" [class.show]="currentLocationTarget === 'receiver' && isMapVisible">
                                            <div class="map-header">
                                                <div class="input-group">
                                                    <input #receiverSearchInput type="text" class="form-control" placeholder="{{'Search for location' | translate}}">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-primary d-none" (click)="searchLocation('receiver')">
                                                            <i class="fas fa-search"></i>
                                                        </button>
                                                        <button type="button" class="btn btn-secondary" (click)="closeMap()">
                                                            <i class="fas fa-times"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="map-content">
                                                <div #receiverMapContainer class="map-view"></div>
                                            </div>
                                            <div class="map-footer">
                                                <button type="button" class="btn btn-primary" (click)="confirmLocation()">
                                                    <i class="fas fa-check"></i> {{'ConfirmLocation' | translate}}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'City' | translate}}</label>
                                    <input type="text" class="form-control" formControlName="receiverCity" [class.is-invalid]="isFieldInvalid('receiverCity')">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('receiverCity')">
                                        {{getErrorMessage('receiverCity') | translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Region/Area' | translate}}</label>
                                    <input type="text" class="form-control" formControlName="receiverRegion" [class.is-invalid]="isFieldInvalid('receiverRegion')">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('receiverRegion')">
                                        {{getErrorMessage('receiverRegion') | translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{'Street' | translate}}</label>
                                    <input type="text" class="form-control" formControlName="receiverStreet">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Building No.' | translate}}</label>
                                    <input type="text" class="form-control" formControlName="receiverBuildingNo">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Apartment No.' | translate}}</label>
                                    <input type="text" class="form-control" formControlName="receiverApartmentNo">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Package Details -->
                    <div class="checkout-card mb-4">
                        <h4 class="text-warning text-style-right">{{'Package Details' | translate}}</h4>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{'Package Type' | translate}} *</label>
                                    <input type="text" class="form-control" [class.is-invalid]="isFieldInvalid('packageType')" formControlName="packageType" 
                                           placeholder="{{'e.g., Electronics, Furniture, Documents, etc.' | translate}}">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('packageType')">
                                        {{getErrorMessage('packageType') | translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{'Package Description' | translate}}</label>
                                    <textarea class="form-control" [class.is-invalid]="isFieldInvalid('packageDescription')" formControlName="packageDescription" rows="3"></textarea>
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('packageDescription')">
                                        {{getErrorMessage('packageDescription') | translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{'Package Weight (kg)' | translate}}</label>
                                    <input type="number" class="form-control" [class.is-invalid]="isFieldInvalid('packageWeight')" formControlName="packageWeight">
                                    <div class="invalid-feedback" *ngIf="isFieldInvalid('packageWeight')">
                                        {{getErrorMessage('packageWeight') | translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{'Vehicle Size' | translate}} *</label>
                                    <div class="row">
                                        <div class="col-md-4" *ngFor="let size of vehicleSizes">
                                            <div class="card vehicle-size-card" 
                                                 [class.selected]="orderForm.get('deliveryCarSizeId').value === size.id"
                                                 (click)="selectVehicleSize(size.id)">
                                                <div class="card-body text-center">
                                                    <img [src]="size.iconUrl ? size.iconUrl : '/assets/img/delivery_car.jpg'" [alt]="size.name" class="mb-2" width="50" height="50">
                                                    <h6>{{size.name}}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="alert alert-warning mt-2 text-style-right" [class.text-right]="current_lang === 'ar'">
                                        <i class="fas fa-exclamation-triangle mr-2"></i>
                                        {{'The choice of vehicle size is at the customer\'s own risk.' | translate}}
                                    </div>
                                    <div *ngIf="deliveryPrice !== null" class="alert alert-info mt-2 text-style-right" [class.text-right]="current_lang === 'ar'">
                                        <i class="fas fa-info-circle mr-2"></i>
                                        <strong>{{'Estimated Delivery Price:' | translate}}</strong> {{deliveryPrice | currency:
                        settingService.getCurrencySymbol()}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{'Notes' | translate}}</label>
                                    <textarea class="form-control" formControlName="notes" rows="3"></textarea>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>{{'Package Images' | translate}} ({{'Optional' | translate}})</label>
                                    <div class="custom-file">
                                        <input type="file" class="custom-file-input" id="packageImages" 
                                               (change)="onFileSelected($event)" multiple accept="image/*">
                                        <label class="custom-file-label" for="packageImages" [class.custom-file-label-right]="current_lang === 'ar'">
                                            {{'Choose files' | translate}}
                                        </label>
                                    </div>
                                    <div class="selected-images mt-2" *ngIf="selectedImages.length > 0">
                                        <div class="row">
                                            <div class="col-md-3 mb-2" *ngFor="let image of selectedImages; let i = index">
                                                <div class="image-preview-container">
                                                    <img [src]="image" class="img-thumbnail">
                                                    <button type="button" class="btn btn-danger btn-sm remove-image" 
                                                            (click)="removeImage(i)">
                                                        <i class="fas fa-times"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <a href="javascript:void(0)" data-toggle="modal" data-target="#paymentMethodsModal">
                                    <div class="mt-3 checkout-card2">
                                     <div class="d-flex">
                                         <div class="p-2">
                                             <span class="fa fa-credit-card"></span>
                                         </div>
                                         <div class="p-2 d-flex flex-column">
                                             <h5>{{'Pay With' | translate}}</h5>
                                             <span>{{paymentMethodText | translate}}</span>
                                         </div>
                                         <div [ngClass]="current_lang == 'en' ? 'ml-auto' : 'mr-auto'" class="p-2">
                                             <span class="text-danger fa fa-exclamation-triangle"></span>
                                         </div>
                                     </div>
                                     </div> 
                                 </a>
                                 <!-- Alert Element -->
                                 <div *ngIf="paymentMethodText != 'Select your payment method'" class="alert alert-info font-weight-bold text-style-right my-1">
                                     {{paymentMethodText | translate}}
                                 </div>
     
                            </div>
                        </div>
                    </div>

                    <!-- Submit Button -->
                    <div class="text-center">
                        <button type="submit" class="btn btn-primary btn-lg" [disabled]="orderForm.invalid || isSubmitting">
                            {{'Place Order' | translate}}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>

<app-footer2 id="footer"></app-footer2>

<!-- Map Container -->
<div #mapContainer id="mapContainer">
    <div class="p-3 d-flex justify-content-between align-items-center bg-light border-bottom">
        <h5 class="mb-0">{{'Select Location' | translate}}</h5>
        <button type="button" class="btn btn-sm btn-secondary" (click)="mapContainer.style.display = 'none'">
            <i class="fas fa-times"></i>
        </button>
    </div>
</div>
<div class="modal fade" id="paymentMethodsModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title text-left">{{'Payment methods' | translate}}</h4>
                <button type="button" class="close text-right" data-dismiss="modal"><span
                        aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
            </div>
            <div class="modal-body">
                <!-- <ng-container *ngFor="let method of getPaymentMethodKeys(); let i = index">
                    <div *ngIf="paymentMethods[method] != 2" (click)="toggleModal(paymentMethods[method])"
                    class="d-flex mb-2 checkout-card2">
                    <div class="p-2">
                        <span class="fa fa-credit-card"></span>
                    </div>
                    <div class="p-2 d-flex flex-column">
                        <h5>{{ method | translate }}</h5>
                    </div>
                    <div *ngIf="paymentNumber === paymentMethods[method]" class="p-2 ml-auto">
                        <span class="text-danger fa fa-check"></span>
                    </div>
                </div>
                </ng-container> -->
                <ng-container *ngFor="let method of getPaymentMethodKeys(); let i = index">
                    <ng-container *ngIf="isApple">
                        <div (click)="toggleModal(paymentMethodIcons[method].numericValue,paymentMethodIcons[method].text)" class="d-flex mb-2 checkout-card2">
                            <div class="p-2">
                              <img class="payment-image" [src]="paymentMethodIcons[method].iconClass" alt="{{ method }} Image">
                            </div>
                            <div class="p-2 d-flex flex-column">
                              <h5>{{ method | translate }}</h5>
                            </div>
                            <div *ngIf="paymentNumber === paymentMethodIcons[method].numericValue" class="p-2 ml-auto">
                              <span class="text-danger fa fa-check"></span>
                            </div>
                          </div>
                    </ng-container>
                    <ng-container *ngIf="!isApple">
                        <div *ngIf="paymentMethodIcons[method].numericValue != 2" (click)="toggleModal(paymentMethodIcons[method].numericValue,paymentMethodIcons[method].text)" class="d-flex mb-2 checkout-card2">
                            <div class="p-2">
                              <img class="payment-image" width="70" [src]="paymentMethodIcons[method].iconClass" alt="{{ method }} Image">
                            </div>
                            <div class="p-2 d-flex flex-column">
                              <h5>{{ method | translate }}</h5>
                            </div>
                            <div *ngIf="paymentNumber === paymentMethodIcons[method].numericValue" class="p-2 ml-auto">
                              <span class="text-danger fa fa-check"></span>
                            </div>
                          </div>
                    </ng-container>
                  </ng-container>
                  
                
                <!-- <div (click)="toggleModal(0)" class="d-flex mb-2 checkout-card2">
                    <div class="p-2">
                        <span class="fa fa-credit-card"></span>
                    </div>
                    <div class="p-2 d-flex flex-column">
                        <h5>{{'Cache' | translate}}</h5>
                    </div>
                    <div *ngIf="paymentNumber == 0" class="p-2 ml-auto">
                        <span class="text-danger fa fa-check"></span>
                    </div>
                </div> -->
                <!-- <div (click)="toggleModal(1)" class="d-flex mb-2 checkout-card2">
                    <div class="p-2">
                        <span class="fa fa-credit-card"></span>
                    </div>
                    <div class="p-2">
                        <h5>Cache</h5>
                    </div>
                    <div *ngIf="paymentNumber == 1" class="p-2 ml-auto">
                        <span class="text-danger fa fa-check"></span>
                    </div>
                </div> -->
                <hr>
                <!-- <p class="fs-12">You will be redirected to the secure (SSL) pages of GiroPay. Here you will be able to
                    complete the GiroPay payment for your order.
                </p> -->
                <button (click)="closeModal()" type="button" class="btn done-btn pt-1 pb-2 w-100">
                    <span>{{'Done' | translate}}</span>
                </button>
            </div>
        </div>
    </div>
</div>